import { createContext, use } from "react"

export interface ErrorBoundaryContextValue {
  showBoundary: (error: unknown) => void
  resetBoundary: () => void
}

export const ErrorBoundaryContext = createContext<ErrorBoundaryContextValue | null>(null)

export const useErrorBoundary = (): ErrorBoundaryContextValue => {
  const context = use(ErrorBoundaryContext)

  if (!context) {
    throw new Error("useErrorBoundary must be used within an ErrorBoundary")
  }

  return context
}
